<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/crs36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  import Qs from 'qs'

  let language={"zh_CN":"中文","en_US":"英文","vi_VN":"越南文","hi_IN":"印度文"};//语言
  let pushType={1:"push推送",2:"站内信"}; //推送类型
  let msgMode={1:"消息中心",2:"消息通知(不进入消息中心)"}; //推送类型
  let messageList ={"1":"重要公告","2":"交易时间安排","3":"系统维护公告","4":"最新优惠","5":"专属回馈","6":"新闻早班车","7":"行情提醒","8":"服务提示","9":"问答快讯","10":"通知"};
 // 存款:(不需要),行情列表(不需要),产品页面(uicode),详情页面(完整资讯URL),链接页面(完整URL)
  let contentType = {0:"编辑内容",1:"存款",2:"行情列表",3:"产品页面",4:"详情页面",5:"链接页面"};
  let msgUrlList = {1:"https://intercept_deposit",2:"https://intercept_market",3:"https://intercept_product",4:process.env.VUE_APP_ZX_URL};
  let autoType = {1:"新安装app-未注册（60分钟）",2:"新安装app-未注册（1天+60分钟）",3:"新安装app-未注册（2天+60分钟）",4:"开户后60分钟-开户积分奖励未领取",5:"开户后24小时--开户积分奖励未领取",6:"开户后3天--开户积分奖励未领取"
    ,7:"开户3天未激活",8:"签到任务未完成",9:"签到任务没领奖",10:"日常交易任务已完成未领取",11:"已激活-未上传身份证",12:"已激活-未上银行卡",13:"已激活-已上传身份证-积分未领取",14:"已激活-已上传银行卡-积分未领取",15:"自己导入的用户分群"}
  let status = {1:"启用",2:"停用"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      /*表格按钮点击事件*/
      bthClick (clickName, row) {
        if (clickName == "update"){
          this.$refs.childUpdate.open(row);
        }else if(clickName == "delete"){
          this.dataChanage(URL.autoMsg.mode.del,{id:row.id},res => {
            this.$refs.childTable.defaultGetData(this.queryData);
            if (res.code == 0){
              this.$message.success("suc");
            }else{
              this.$message.error(res.message);
            }
          })
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data) {
        if ("查询" == clickName) {
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        } else if ("新增" == clickName) {
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage(URL.autoMsg.mode.edit,model,res => {
          this.$refs.childTable.defaultGetData(this.queryData);
          if (res.code == 0){
            this.$refs.childUpdate.close();
            this.$message.success("suc");
          }else{
            this.$message.error(res.message);
          }
        })
      },
      dataChanage(url,option,suc,fail){
        this.axios.post(url, Qs.stringify(option || {})).then(res => {
        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
            { title: 'id', field: 'id',hidden:true},
            { title: '消息名称', field: 'msgName',required:true},
            { title: '推送方式', field: 'pushConfig',type:3,optionList: pushType,isNumber:true,required:true},
            { title: '消息模式', field: 'msgMode',type:3,optionList: msgMode,isNumber:true,required:true},
            { title: '消息类型', field: 'msgType',type:2,optionList: messageList,isNumber:true,required:true},
            { title: '触发类型', field: 'autoType',type:2,optionList: autoType,isNumber:true,required:true},
            { title: '语言', field: 'msgLanguage',type:3,optionList: language,required:true},
            { title: '消息标题', field: 'msgTitle',required:true},
            { title: '推送内容类型', field: 'contentType',type:2,required:true,isNumber:true,optionList:contentType,data:0,change:(model,cols)=>{
                let col = {};
                for (let i in cols){
                  if (cols[i].field == "msgUrl") col = cols[i];
                }
                let data = msgUrlList[model.contentType] || "";
                this.$set(col,"data",data);
              }},
            { title: '消息内容', field: 'msgContent',type:14,required:(model,col)=>{return model.contentType == "0"},isNumber:true,hidden:(model,col)=>{return  model.contentType != "0"}},
            { title: '自定义推送地址', field: 'msgUrl',required:(model,col)=>{return model.contentType != "0"},isNumber:true,hidden:(model,col)=>{return  !model.contentType || model.contentType == "0"}},
            { title: '状态', field: 'status',type:3,optionList:status,isNumber:true,required:true },
          ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title: '消息名称', field: 'msgName'},
              {click:"查询"},
              {click:"新增"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.autoMsg.mode.qurey, //请求路径和参数
          sequence: true,
          cols: [
              { title: 'id', field: 'id'},
              { title: '触发类型', field: 'autoType',render:(data,full)=>{
                return autoType[data];
                }},
              { title: '语言', field: 'msgLanguage',render:(data,full)=>{
                  return language[data];
                }},
              { title: '推送方式', field: 'pushConfig',render:(data,full)=>{
                  return pushType[data];
                }},
              { title: '消息类型', field: 'msgType',render:(data,full)=>{
                  return messageList[data];
                }},
              { title: '消息模式', field: 'msgMode',render:(data,full)=>{
                  return msgMode[data];
                }},
              { title: '消息名称', field: 'msgName'},
              { title: '消息标题', field: 'msgTitle'},
              { title: '状态', field: 'status',render:(data,full)=>{
                  return status[data];
                }},
              { title: '推送内容类型', field: 'contentType',render:(data,full)=>{
                  return contentType[data];
                }},
              { title: '推送次数', field: 'pushTime'},
              { title: '送达次数', field: 'getTime'},
              { title: '点击次数', field: 'clickTime'},
              { title: '创建人', field: 'creator'},
              { title: '修改人', field: 'updater'},
              { title: '创建时间', field: 'createTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
              { title: '修改时间', field: 'updateTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
            {title: window.$t('crs36.bt.operation'),width: 300,btnClick:
                [
                  {name: window.$t('crs36.bt.edit'),click:"update",type:"primary",icon:"el-icon-edit"},
                  {name:window.$t('crs36.bt.delete'),click:"delete",type:"primary",icon: "el-icon-delete"},
              ]},
          ]
        }
      }
    }
  }
</script>
